import { atom } from "recoil";

export const memberFilterState = atom({
  key: "memberFilterState",
  default: {
    title: "",
    type: "NONE",
  },
});
